import { Button } from 'antd'
import Heading from 'components/Heading'
import paths from 'constants/paths'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import withLayout from 'components/layout'

import '../../global/styles/global.less'

const RobHome = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <div className="page__container">
      <Heading level={2}>{t('rob.home.title')}</Heading>
      <Button onClick={() => navigate(paths.robSurvey)} type="primary">
        {t('rob.home.robSurveyButton')}
      </Button>
    </div>
  )
}

export default withLayout(RobHome)
